import { render, staticRenderFns } from "./DettagliAnagrafica.vue?vue&type=template&id=45da11f8&"
import script from "./DettagliAnagrafica.vue?vue&type=script&lang=js&"
export * from "./DettagliAnagrafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports